<template>
  <v-container class="banner-menu">
    <v-layout class="banner-menu-container" wrap justify-center :column="mobile">
      <v-flex v-for="(item, i) in value" :key="item.id" xs4 :style="`height: ${height}px;`" @click="click(item.url)">
        <banner class="banner-menu-item" :value="item.source" :interval="interval + i * delay" darken inside hover :loading="loading" :essential="essential">
          <slot :name="item.title" />
        </banner>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Banner from '@/components/Banner'

export default {
  name: 'banner-menu',
  components: { Banner },
  props: {
    value: { type: Array, default: () => [] },
    height: { type: Number, default: 420 },
    interval: { type: Number, default: 5000 },
    delay: { type: Number, default: 200 },
    loading: Boolean,
    essential: Boolean
  },
  methods: {
    click (url) {
      if (url) { this.$router.push(url) }
    }
  },
  computed: {
    mobile () { return this.$vuetify.breakpoint.smAndDown }
  }
}
</script>

<style lang="scss">
.banner-menu {
  .banner-menu-container { box-shadow: 0 0 20px 0 rgba(0, 0, 0, .05); }
  .banner-menu-item:hover { cursor: pointer; }
}
</style>
